<template>
    <div>
        <el-dialog title="发货" :visible="showDialog" width="800" @close="closeDialog()">
            <el-form
                :model="deliveryData"
                ref="orderDelivery"
                label-width="120px"
                :inline="true"
                size="small"
                :rules="rules"
            >
                <el-form-item
                    label="订单编号"
                    prop="goodsName"
                >
                    <el-input
                        style="width: 200px"
                        size="small"
                        placeholder="请输入订单编号"
                        disabled
                        v-model="deliveryData.orderCode"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="是否分批"
                    prop="isPartOrder"
                >
                    <el-select
                        size="small"
                        v-model="deliveryData.isPartOrder"
                    >
                        <el-option
                            v-for="(item,index) in yesNoEnumList"
                            :key="index"
                            :label="item.value"
                            :value="item.key"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialog()">取 消</el-button>
                <el-button type="primary" @click="onSubmit()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { get } from '@/utils/request.js';
export default {
    props:{
        showDialog:{
            type: Boolean,
            default: false,
        },
        youzhicaiOrder:{
            type: Object,
            default: {},
        },
    },
    watch:{
        youzhicaiOrder:{
            handler(newValue){
                this.deliveryData.orderCode = newValue.orderCode
            },
            deep:true
        }
    },
    data() {
        return{
            deliveryData: {
                orderCode: "", // 优质采订单唯一编号
                isPartOrder: "", // 是否分批发货
            },
            yesNoEnumList: [],
            rules: {
                isPartOrder: [{ required: true, message: '是否分批发货不能为空', trigger: 'blur' }],
            },
        }
    },
    created() {
        this.getYesNoEnum();
    },
    methods: {
        closeDialog(){
            this.$emit("closeDeliveryDialog")
        },
        onSubmit(){
            if(this.deliveryData.isPartOrder == 1){
                this.$message({
                    message: '暂不支持分批发货',
                    type: 'error',
                    duration: 2000
                });
                return
            }

            this.$refs.orderDelivery.validate((valid) => {
                if(valid){
                    get("/youzhicai/order/delivery",{
                        id: this.youzhicaiOrder.id,
                        ...this.deliveryData
                    }).then((res)=>{
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.closeDialog()
                            this.$emit("resetDialog")
                            this.$emit("resetYouzhicaiOrderList")
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    })
                }
            })
        },

        // 获取yes_no枚举
        getYesNoEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'yes_no'
            }).then((res) => {
                if (res.success) {
                    this.yesNoEnumList = res.enumList;
                }
            });
        },
    }
};
</script>
<style lang="scss" scoped>

</style>